import { Home } from "react-feather"
import { ACL_READ } from "@configs/acl/constants"

export default [
  {
    id: "dashboard",
    title: "Dashboard",
    icon: <Home />,
    navLink: "/dashboard/person",
    action: ACL_READ,
    resource: "Dashboard"
  }
]
